import { isNewSince } from "../../hooks/useSeenStages";

const time = (v) => new Date(v?.$date ?? v ?? 0).getTime();
const raw = (v) => v?.$date ?? v;

/**
 * One row per deal, from the deal headers and the placing summaries:
 * { deal, placements, lead (the placement to show: one that needs you,
 * else the furthest along), needsYou (count), isNew, stageKeys, updated }.
 * isNew: a carrier did something on one of its placements since that
 * stage was last opened (seen from useSeenStages).
 */
export const dealRows = (deals, summaries, seen) =>
  deals.map((deal) => {
    const placements = summaries.filter((s) => s.placement.dealId === deal._id);
    const needing = placements.filter((s) => s.needsYou);
    const furthest = [...placements].sort((a, b) => b.stageIndex - a.stageIndex || time(b.updated) - time(a.updated))[0];
    const updated = [raw(deal.updatedDate), raw(deal.createdDate), ...placements.map((s) => s.updated)]
      .filter(Boolean)
      .sort((a, b) => time(b) - time(a))[0] || null;
    return {
      deal,
      placements,
      lead: needing[0] || furthest || null,
      needsYou: needing.length,
      isNew: placements.some((s) => isNewSince(seen, s.stageKey, s.carrierUpdated)),
      stageKeys: [...new Set(placements.map((s) => s.stageKey))],
      updated,
    };
  });

/** Rows filtered by stage, the needs-you switch, product and search text; needing you first, then newest. */
export const filterDealRows = (rows, { stage, needsOnly, product, search, productNames = {} }) => {
  const text = String(search || "").trim().toLowerCase();
  return rows
    .filter((r) => !stage || r.stageKeys.includes(stage))
    .filter((r) => !needsOnly || r.needsYou > 0 || r.isNew)
    .filter((r) => !product || r.deal.productCode === product)
    .filter((r) => !text || [r.deal.name, productNames[r.deal.productCode], r.deal.productCode, ...r.placements.map((s) => s.placement.name)]
      .some((v) => String(v || "").toLowerCase().includes(text)))
    .sort((a, b) => (b.needsYou > 0) - (a.needsYou > 0) || time(b.updated) - time(a.updated));
};
